module.exports = __webpack_public_path__ + "static/media/title.1cf2126f.png";